export default __webpack_public_path__ + "static/media/arrow_top.98be3911.png";